import ServiceBase from './ServiceBase';
import NoteTaskSave from '../models/NoteTaskSave';
import NoteTaskReq from '../models/NoteTaskReq';

export default class NoteTaskService extends ServiceBase {

    public GetNotesAndTasks(noteReq: NoteTaskReq): Promise<any> {

        return this.post('Note/GetNotesTasksDocketing', noteReq)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/GetNotesTasksDocketing erred');
            })
    }

    public PrintNotes(req: any): Promise<any> {
        return this.streamFiles('Document/CreateNoteTaskPDF', req)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('PrintNotes erred');
            })
    }

    public AddOrUpdateNote(req: NoteTaskSave): Promise<any> {
        return this.put('Note/AddOrUpdateNote', req)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('AddOrUpdateNote erred');
            })
    }

    public GetNoteDetailsByPkNoteID(req: any): Promise<any> {
        return this.post('Note/GetNoteTaskDetails', req)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetNoteTaskDetails erred');
            })
    }

    public GetNoteDetails(req: any): Promise<any> {
        return this.post('Note/GetNoteTaskDetailsList', req)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetNoteTaskDetailsList erred');
            })
    }

    public UploadFiles(req: any, username: string): Promise<any> {
        console.log('uploading file to server.');
        let formData = new FormData();
        for (let i = 0; i <= req.length - 1; i++) {
            if (req[i].file)
                formData.append(req[i].file.name, req[i].file, req[i].fileName);
            else
                console.log('File object missing indicates file was already uploaded');
        }
        formData.append("username", username);

        return this.uploadFiles(formData)
            .then((response) => {
                console.log('file upload complete on server for ' + response[0].filePath);
                return response;
            })
            .catch(error => {
                console.log('UploadFiles erred');
            })
    }

    public UpdateNoteTask(req: NoteTaskSave): Promise<any> {
        return this.put('Docketing/UpdateNoteTask', req)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('UpdateNoteTask erred');
            })
    }

    public GetActiveCMIUsers(): Promise<any> {

        return this.get('RefNote/GetActiveCMIUsers')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('RefNote/GetActiveCMIUsers erred');
            })
    }

    public GetUserDepartments(username: string): Promise<any> {

        return this.post('Note/GetUserDepartments', { UserName: username })
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/GetUserDepartments erred');
            })
    }

    public GetHearingReps(): Promise<any> {

        return this.get('RefNote/GetHearingReps')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('RefNote/GetHearingReps erred');
            })
    }

    public GetDepartments(): Promise<any> {

        return this.get('RefNote/GetDepartments')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/GetDepartments erred');
            })
    }

    public GetUserCompany(username: string): Promise<any> {

        return this.post('Note/GetUserCompany', { UserName: username })
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/GetUserCompany erred');
            })
    }

    public GetNoteCategories(Company: number, Category: number, username: string): Promise<any> {

        return this.post('Note/GetNoteCategories', { pkCompany: Company, pkDepartment: Category, UserName: username })
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/GetNoteCategories erred');
            })
    }

    public GetNoteSubjects(Company: number, Department: number, Category: number): Promise<any> {

        return this.post('Note/GetNoteSubjects', { pkCompany: Company, pkDepartment: Department, pkCategory: Category })
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/GetNoteSubjects erred');
            })
    }

    public SendEmail(emailObj: any): Promise<any> {
        return this.post('Docketing/SendEmail', emailObj)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Note/SendEmail erred');
            })
    }

    public ViewFile(fileName: string): Promise<any> {
        return this.post('Document/GetFile', fileName)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('Document/GetFile erred');
            })
    }

    public GetUserEmailSignature(username: string): Promise<any> {
        return this.post('Note/GetEmailSignature', { UserName: username })
            .then((response) => {
                return response;
            })
            .catch(error => console.log('GetEmailSignature err'));
    }

    public SaveNoteAttachments(req: any): Promise<any> {
        return this.post('Note/AddOrUpdateNoteAttachment', req)
            .then((response) => {
                return response;
            })
            .catch(error => console.log('Note/AddOrUpdateNoteAttachment err'));
    }

    public SaveNoteAssignments(req: any): Promise<any> {
        return this.post('Note/CompleteTask', req)
            .then((response) => {
                return response;
            })
            .catch(error => console.log('Note/CompleteTask err'));
    }
}



// WEBPACK FOOTER //
// ./ClientApp/src/services/NoteTaskService.ts